// @flow

import React from 'react';
import Translate from 'client/components/translate';
import Notification from 'client/components/notification';

type Props = {
  headerTranslationKey: string,
  bodyTranslationKey?: string,
  using?: Object,
  className?: string,
  theme: 'green' | 'orange' | 'red',
};

const ErrorNotification = ({
  className,
  theme,
  headerTranslationKey,
  bodyTranslationKey,
  using,
}: Props) => {
  if (!headerTranslationKey) return null;

  return (
    <Notification theme={theme} border borderPosition="bottom" className={className}>
      <div className="text-center notification-text">
        <h4 className="red-1-color bold">
          <Translate path={headerTranslationKey} using={using} />
        </h4>
        {bodyTranslationKey ? (
          <h5 className="grey-2-color normal">
            <Translate path={bodyTranslationKey} using={using} />
          </h5>
        ) : null}
      </div>
    </Notification>
  );
};

ErrorNotification.defaultProps = {
  bodyTranslationKey: '',
  using: {},
  className: '',
  theme: 'red',
};

export default ErrorNotification;
